import { render, staticRenderFns } from "./SelectorMap.vue?vue&type=template&id=8a9b3f5a&scoped=true&"
import script from "./SelectorMap.vue?vue&type=script&lang=js&"
export * from "./SelectorMap.vue?vue&type=script&lang=js&"
import style0 from "./SelectorMap.vue?vue&type=style&index=0&id=8a9b3f5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9b3f5a",
  null
  
)

export default component.exports